import { Box, Text } from 'grommet';
import React, { useEffect, useState } from 'react';
import { snakeCase } from '../../utils/string';
import Button from '../Button';
import FontAwesomeIcon from '../FontAwesomeIcon';
import BasePaymentForm from './BasePaymentForm';
import Loading from "../Loading";

const PaymentMethodsMenu = ({
    methods, 
    onSelect, 
    isBulkPay, 
    onBack,
    backBtnText
}) => {
    const [isClient, setIsClient] = useState(false);
    useEffect(() => setIsClient(true), []);

    const menu = (methods || []).map(method => (
        <Box key={method.paymentMethod}>
            <Button
                event={{section: 'checkout_payment_method_menu', element: snakeCase(method.serviceName)}}
                margin={{vertical: "xxsmall"}}
                secondary
                hoverIndicator
                onClick={() => {
                    onSelect(method);
                }}
                label={
                    <Box margin={{horizontal: 'none', vertical:'xxsmall'}} direction="row" align="center" gap="small">
                        {isClient ? (<FontAwesomeIcon size="small" SelectedIcon={method.icon} />) : ''}
                        <Text lineHeight="40px" weight={400} size="medium" truncate={true}>
                            {method.serviceName}
                        </Text>
                    </Box>
                }
                data-testid={`checkout-menu-${method.paymentMethod}`}
            />
        </Box>
    ));
    return (
        <BasePaymentForm heading="Pay invoice with" isBulkPay={isBulkPay}>
            <Box direction="column">
                {menu.length === 0 && <Loading />}
                {menu}
            </Box>
            {onBack && (
                <Box
                    direction="row"
                    fill="horizontal"
                    justify="between"
                    margin={{top: 'small'}}
                    align="start">
                    <Button
                        event={{section: 'checkout_pay_invoice_with', element: 'cancel'}}
                        secondary
                        onClick={onBack}
                        key="cancel"
                        hoverIndicator
                        label={backBtnText || 'Back'} />
                </Box>
            )}
        </BasePaymentForm>
    );
};

export default PaymentMethodsMenu;